(function () {
  'use strict';

  var PLUS_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><line x1="12" y1="4" x2="12" y2="20"/><line x1="4" y1="12" x2="20" y2="12"/></svg>';
  var MINUS_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><line x1="4" y1="12" x2="20" y2="12"/></svg>';

  document.addEventListener('DOMContentLoaded', function () {
    initScrollFade();
    initHeaderScroll();
    initMobileNav();
    initProductGallery();
    initVariantPicker();
    initQuantitySteppers();
    initProductForm();
    initCartDrawer();
    initCartPageQuantities();
  });

  function initScrollFade() {
    var els = document.querySelectorAll('[data-scroll-fade]');
    if (!els.length) return;

    var animationsEnabled = !window.zenithTheme || window.zenithTheme.animationsEnabled !== false;
    if (!animationsEnabled || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('MobileNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var lightbox = document.querySelector('[data-product-lightbox]');
    var lightboxImage = lightbox ? lightbox.querySelector('[data-lightbox-image]') : null;

    function setActive(index) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', Number(slide.dataset.index) === index);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(Number(thumb.dataset.index));
      });
    });

    slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        if (!lightbox || !lightboxImage) return;
        var img = slide.querySelector('img');
        if (!img) return;
        lightboxImage.src = img.src.replace(/width=\d+/, 'width=2200');
        lightboxImage.alt = img.alt;
        openLightbox();
      });
    });

    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', closeLightbox);
      });
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeLightbox();
      });
    }

    function openLightbox() {
      if (!lightbox) return;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    gallery._setActiveSlide = setActive;
  }

  function initVariantPicker() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var variantScript = form.querySelector('[data-product-variants]');
    if (!variantScript) return;

    var variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    var selects = form.querySelectorAll('[data-option-selector]');
    var variantIdInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonText = form.querySelector('[data-add-to-cart-text]');
    var gallery = document.querySelector('[data-product-gallery]');

    function currentSelection() {
      return Array.prototype.map.call(selects, function (select) { return select.value; });
    }

    function findVariant(selection) {
      return variants.filter(function (variant) {
        return variant.options.every(function (option, index) { return option === selection[index]; });
      })[0];
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'Unavailable';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) addButtonText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      if (gallery && variant.featured_media) {
        var slide = gallery.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media.id + '"]');
        if (slide && gallery._setActiveSlide) gallery._setActiveSlide(Number(slide.dataset.index));
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findVariant(currentSelection()));
      });
    });
  }

  function initQuantitySteppers() {
    document.querySelectorAll('[data-quantity-decrease]').forEach(function (btn) {
      if (btn.closest('[data-cart-drawer]') || btn.hasAttribute('data-cart-quantity-decrease')) return;
      btn.addEventListener('click', function () { stepProductQuantity(btn, -1); });
    });
    document.querySelectorAll('[data-quantity-increase]').forEach(function (btn) {
      if (btn.closest('[data-cart-drawer]') || btn.hasAttribute('data-cart-quantity-increase')) return;
      btn.addEventListener('click', function () { stepProductQuantity(btn, 1); });
    });
  }

  function stepProductQuantity(btn, delta) {
    var input = btn.parentElement.querySelector('.product__quantity-input');
    if (!input) return;
    var min = Number(input.min) || 1;
    input.value = Math.max(min, Number(input.value) + delta);
  }

  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form || !window.zenithTheme || window.zenithTheme.cartType !== 'drawer') return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var addButton = form.querySelector('[data-add-to-cart]');
      var variantId = form.querySelector('[data-variant-id]').value;
      var quantityInput = form.querySelector('input[name="quantity"]');

      if (addButton) addButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: Number(quantityInput ? quantityInput.value : 1) || 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart-failed');
          return fetchCart();
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (addButton) addButton.disabled = false;
        });
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCartDrawer();
    });

    drawer.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-quantity-decrease], [data-cart-quantity-increase]');
      if (!btn) return;
      var isDecrease = btn.hasAttribute('data-cart-quantity-decrease');
      var display = btn.parentElement.querySelector('[data-cart-quantity-display]');
      var current = display ? Number(display.textContent) : 0;
      var next = Math.max(0, current + (isDecrease ? -1 : 1));
      changeCartLine(btn.dataset.line, next);
    });

    if (window.zenithTheme && window.zenithTheme.cartType === 'drawer') {
      var cartIcon = document.querySelector('[data-cart-icon-bubble]');
      if (cartIcon) {
        cartIcon.addEventListener('click', function (event) {
          event.preventDefault();
          openCartDrawer();
        });
      }
    }
  }

  function initCartPageQuantities() {
    var cartTable = document.querySelector('.cart-table');
    if (!cartTable) return;

    cartTable.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-quantity-decrease], [data-cart-quantity-increase]');
      if (!btn) return;
      var isDecrease = btn.hasAttribute('data-cart-quantity-decrease');
      var row = btn.closest('[data-cart-line]');
      var input = row ? row.querySelector('[data-cart-quantity-input]') : null;
      if (!input) return;
      input.value = Math.max(0, Number(input.value) + (isDecrease ? -1 : 1));
      input.form.requestSubmit();
    });

    cartTable.querySelectorAll('[data-cart-quantity-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        input.form.requestSubmit();
      });
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
  }

  function renderCartDrawer(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var headerCount = document.querySelector('[data-cart-count]');

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.classList.toggle('is-hidden', cart.item_count === 0);
    }

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    itemsContainer.innerHTML = cart.items.map(function (item, index) {
      var line = index + 1;
      var image = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';
      var variantMarkup = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      return (
        '<div class="cart-drawer__item" data-cart-line="' + line + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-media">' + image + '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantMarkup +
            '<div class="product__quantity product__quantity--small">' +
              '<button type="button" class="product__quantity-btn" data-cart-quantity-decrease data-line="' + line + '" aria-label="Decrease quantity">' + MINUS_ICON + '</button>' +
              '<span data-cart-quantity-display>' + item.quantity + '</span>' +
              '<button type="button" class="product__quantity-btn" data-cart-quantity-increase data-line="' + line + '" aria-label="Increase quantity">' + PLUS_ICON + '</button>' +
            '</div>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>'
      );
    }).join('');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var format = (window.zenithTheme && window.zenithTheme.moneyFormat) || '${{amount}}';
    var amount = (Number(cents) / 100).toFixed(2);
    var amountNoDecimals = Math.round(Number(cents) / 100).toString();
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals);
  }
})();
